/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".circle-visio[_ngcontent-%COMP%]{padding-top:3.75rem}@media (min-width:768px){.circle-visio[_ngcontent-%COMP%]{padding-top:4.375rem}}@media (min-width:992px){.circle-visio[_ngcontent-%COMP%]{padding-top:0}}@media (max-width:991.98px){.circle-visio[_ngcontent-%COMP%]{position:fixed;top:5.25rem;left:0;bottom:0}}"];
export { styles as styles };
